module.exports = __webpack_public_path__ + "media/images/top/keisan_club_marutsuke-min-db97d58f52061c87ccce6fb4d3dac4ea.png";